import { connect } from 'react-redux';
import PendingRequests from './PendingRequests';

// Import actions
import {
  getMembersList,
  getInvitedMembersList,
  removeMember,
  inviteMember,
  deleteMemberInvitation,
  updateMember,
  getPendingRequests,
  bulkUpdateFromPendingRequests,
} from '../membersActions';
import { updateMemberwiseTimesheetApprovalSettings } from '../../Settings/TimesheetSettings/timesheetSettingsActions';
import { getOfficesShortList } from '../../Offices/officesActions';

// Store props to map with current state
const mapStateToProps = (state) => ({
  isLoading: state.member.isLoading,
  deleteInvitationLoading: state.member.deleteInvitationLoading,
  deleteMemberLoading: state.member.deleteMemberLoading,
  selectedOrganization: state.organization.selectedOrganization,
  membersList: state.member.members,
  updatedData: state.member.updatedData,
  invitedMembersList: state.member.invitedMembersList,
  officesShortList: state.office.officesShortList,
  // pagination
  totalMembersCount: state.member.totalMembersCount,
  pageSize: state.member.pageSize,
  pendingRequestsLoading: state.member.pendingRequestsLoading,
  pendingRequestsData: state.member.pendingRequests || [],
  bulkUpdateFromPendingRequestsLoading: state.member.bulkUpdateFromPendingRequestsLoading,
});

// Map dispatch actions to props
const mapDispatchToProps = {
  getMembersList,
  getInvitedMembersList,
  removeMember,
  inviteMember,
  deleteMemberInvitation,
  updateMember,
  updateMemberwiseTimesheetApprovalSettings,
  getOfficesShortList,
  getPendingRequests,
  bulkUpdateFromPendingRequests,
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingRequests);